import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import {
  getReadableValue,
  parameterTitleMap,
  measurementTypeMap,
  currentMeasurementTypeMap,
} from '../../../../utils/helpers'
import { SummaryRow } from './utils'

export function LocationSummary({ data }: { data: any }) {
  const filteredData = data?.filter((param) => param.total !== 0)

  return (
    <Flex
      width={{ base: '100%', desktopLg: '600px' }}
      height="max-content"
      direction="column"
      visibility={!filteredData || filteredData.length === 0 ? 'hidden' : 'visible'}
      borderRadius="xl"
      p={4}
      bg="white"
      boxShadow="sm"
    >
      <Text fontWeight={700} fontSize="15px" fontFamily="Inter" color="#484848">
        Summary
      </Text>
      <Box>
        <VStack spacing={2} align="stretch">
          {filteredData?.map((param) => (
            <Box key={param.parameter_title}>
              <SummaryRow
                title={getReadableValue(parameterTitleMap, param.parameter_title)}
                total={param.total}
                prevTotal={param.prev_total}
                currentValue={param.current_value}
                totalUnit={getReadableValue(measurementTypeMap, param.parameter_title)}
                currentUnit={getReadableValue(
                  currentMeasurementTypeMap,
                  param.parameter_title,
                )}
                showAverageHint={/temperature|humidity/i.test(param.parameter_title)}
              />
              <Box h="1px" bg="#EFF1F4" mx={1} my={2} /> {/* subtle divider */}
            </Box>
          ))}
        </VStack>
      </Box>
    </Flex>
  )
}
